import React, { useEffect, useRef, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import "../../assets/css/partials/corporates/packageDetails.scss";
import backIcon from "../../assets/images/common/back-icon.svg";
import packageInfo from "../../assets/images/dummy/package-info.png";
import * as CorporateAction from "../../redux/actions/corporatesAuthActions";
import ContactDetailsCard from '../common/contactDetailsCard';
import HolidayRangePicker from "../holidays/holidayRangePicker";
import * as HolidaysAction from "../../redux/actions/holidaysActions";
import closeIcon from "../../assets/images/common/close-modal.svg";
import Footer from "../common/footer";
import Loader from '../common/loader';
import GuestsModal from "../common/guestsModal";
import Header from "../common/header";
import CalenderModal from "./calenderModal";
import ExperiencesNearby from "./experiencesNearby";
import SimilarOffers from "./similarOffers";
import moment from 'moment'
import NearByExperiences from '../corporates/nearByExperiences';
import SanitizedStayTagPopup from "../common/sanitizedStayPopup";
import * as HomeAction from '../../redux/actions/homeAction';
import { Helmet } from "react-helmet";
import PackageDetailsCarousel from '../common/packageDetailsCarousel';
import $ from 'jquery';
import Testimonials from '../common/testimonial';
import TestimonialPopup from "../common/testimonialPopup";
import useClickOutside from '../../hooks/useClickOutside';
import ViewMorePackages from "./viewMorePackages";
import { ScrollToTop } from "../common";
import "../../assets/css/partials/common/priceNotes.scss"
import PriceNote from "../common/priceNote";
import Home from "./home";
import { Redirect } from 'react-router'
import {
  scheduleDuration,
  specificScheduleDuration,
} from "../utilities/utillFunc";
import Breadcrum from "../common/breadcrum";
import ItineraryFeatures from "../common/packageDetails/itineraryFeaturesCard";
import PackageTabsHolder from "../common/packageDetails/packageTabsHolder";
import HolidayHeader from "../common/holidayHeader";
import StayFeaturesCard from "../common/packageDetails/stayFeaturesCard";
import ItineraryEnquiryForm from "../common/packageDetails/itineraryEnquiryForm";
import Amenities from "../common/packageDetails/amenities";
import ItineraryPackageDates from "../common/packageDetails/itineraryPackageDates";
import CustomerReviews from "../common/packageDetails/customerRevews";
import * as ProfileAction from "../../redux/actions/profileAction";
const PACKAGE_IMAGES = [`${packageInfo}`, `${packageInfo}`, `${packageInfo}`];

const owl_images = {
  items: 1,
  margin: 2,
  nav: false,
  loop: true,
  dots: true,
  autoplay: true,
  smartSpeed: 500,
  animateIn: 'fadeIn',
  animateOut: 'fadeOut',

};

const PackageDetails = (packageDetailsPage) => {
  const location = useLocation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const isPack = params.get('isPack');
  const isSimilarOffer =  JSON.parse(isPack);
  const dispatch = useDispatch()
  const history = useHistory();
  const packageID = packageDetailsPage.match.params.id;
  const activePackageIndex = useSelector(
    (state) => state?.corporates?.activePackageIndex
  );
  const PACKAGE_DETAILS = useSelector(state => state.corporates?.corporates_package_details?.data);
  const CORPORATE_PACKAGES = useSelector((state) => state.corporates?.corporates_packages.data);
  const CORPORATE_TESTIMONIALS = useSelector(state => state?.corporates?.corporates_testimonial?.data);
  const guestData = useSelector(state => state.corporates?.guestData);
  const referenceId = useSelector((state) => state?.corporates?.referenceId);
  const reviewStatus = useSelector((state) => state?.corporates?.reviewStatus);
  const reviewList = useSelector((state) => state?.corporates?.reviewList);
  const corporatesReviewListTotalPage = useSelector((state) => state?.corporates?.reviewListTotalPage);
  const corporatesReviewListCurrentPage = useSelector((state) => state?.corporates?.reviewListCurrentPage);
  const IMAGES = PACKAGE_DETAILS && PACKAGE_DETAILS?.corporate?.packages[activePackageIndex]?.images;
  const initialPackageData = PACKAGE_DETAILS && PACKAGE_DETAILS?.corporate?.packages[activePackageIndex];
  const USER_DETAILS = useSelector(
    (state) => state.userProfile?.profile_details?.data
  );
  const [request, setRequest] = useState('')
  const [showModal, setShowModal] = useState(false);
  const [showCalenderModal, setShowCalenderModal] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [flexiDates, setFlexiDates] = useState([])
  const [resAPIStartDate, setResAPIStartDate] = useState(null);
  const [resAPIEndDate, setResAPIEndDate] = useState(null);
  const [resAPISelectedDates, setResAPISelectedDates] = useState(null);
  const [packageIdGet, setPackageId] = useState(PACKAGE_DETAILS?.corporate?.packages[0].id)
  const [adultGuestCount, setAdultGuestCount] = useState(0);
  const [childrensGuestCount, setChildrensGuestCount] = useState(0);
  const [count, setCount] = useState(0);
  const [dataChangedBool, setDataChangedBool] = useState(false);
  const [dataChanged, setDataChanged] = useState({});
  const [totalPrice, setotalPrice] = useState(initialPackageData?.points);
  const [calendarDuration, setCalendarDuration] = useState();
  const [loader, setLoader] = useState(true);
  const [showContactModal, setShowContactModal] = useState(false)
  const [scroll, setScroll] = useState(false);
  const [showTestimonialPopup, setShowTestimonialPopup] = useState(false);
  const [showPoupupDateRangeModal, setShowPoupupDateRangeModal] = useState(true);
  const [popupData, setPopupData] = useState("");
  const [testimonialSH, setTestimonialSH] = useState({});
  const [showDateRangeModal, setShowDateRangeModal] = useState(false);
  const [categoryChanged, setcategoryChanged] = useState(false);
  const [isStuck, setIsStuck] = useState(false);
  const [category, setCategory] = useState("Overview");
  const [categoryId, setCategoryId] = useState("overview");
  const userInfo = JSON.parse(localStorage.getItem("userData"));
  const [showForm, setShowForm] = useState(false);
  const companyDomain = userInfo?.organisation?.email_domain;
  const isWipro = (companyDomain === "wipro.com");
  const isFiltered = JSON.parse(localStorage.getItem("filteredList"));
  const isRecurring = dataChangedBool ? dataChanged?.schedule_type == "recurring" : initialPackageData?.schedule_type == "recurring";
  const isSpecific = dataChangedBool
    ? dataChanged?.schedule_type == "specific_dates"
    : initialPackageData?.schedule_type == "specific_dates";
  const isDateRange = dataChangedBool
    ? dataChanged?.schedule_type == "date_range"
    : initialPackageData?.schedule_type == "date_range";
  const isPackage = dataChangedBool ? dataChanged?.schedule_type == "package" : initialPackageData?.schedule_type == "package"
  const packageData = dataChangedBool ? dataChanged?.schedule_data : initialPackageData?.schedule_data;
  const packageType = initialPackageData && initialPackageData.package_type;
  const isInternational = PACKAGE_DETAILS?.corporate?.section?.name === "International"
  const recurringData = dataChangedBool
    ? dataChanged?.schedule_data
    : initialPackageData?.schedule_data;
  const specificData = dataChangedBool
    ? dataChanged?.schedule_data
    : initialPackageData?.schedule_data;
  const isFlexible = dataChangedBool ? dataChanged?.flexi_schedule : initialPackageData?.flexi_schedule;
  const isEnablePayment = dataChangedBool ? dataChanged?.enable_payment : initialPackageData?.enable_payment;
  const isCorporate = useSelector(
    (state) => state.auth.login_user_otp?.corporate_account
  );
  const isStay = packageType == "staybased"
  const isItinerary = packageType == "itinerary"
  const pointsEl = useRef(null);
  const days = packageData?.days;
  const nights = packageData?.nights;
  let flexiDatesLength = flexiDates?.length;
  let dateRangeMinDays = null;
  let dateRangeMaxDays = null;
  const myRef = useRef(null)
  const SCROLL_REF = useSelector((state) => state.holidays.set_Scroll);
  const [activePackId, setActivePackId] = useState(initialPackageData?.id)
  const[packageChanged,setPackageChanged]=useState(false)
  useEffect(() => {
    if (SCROLL_REF) {
      let idx = localStorage.getItem("cor-actidx");
      if (idx) {
        packageChangeHandler(idx)
      }

      dispatch(HolidaysAction.setScroll(false))


    }
  }, [SCROLL_REF])
  const executeScroll = () => {
    if (isItinerary) {
      if (categoryId == "dates") {
        scrolltoView()
      }
      setCategory(Dates);
      setCategoryId("dates");
      setcategoryChanged(true);


    } else {
      myRef.current.scrollIntoView();
      setTimeout(() => document
        .querySelector(".moblie-tab-holder")
        ?.classList.remove("fixed"), 200)
      pauseVideos();
    }
  };
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const popupRef = useRef();
  useClickOutside(popupRef, (e) => {
    setTimeout(() => setShowVideoPopup(false), 100)

  });
  const contactModalRef = useRef();
  useClickOutside(contactModalRef, (e) => {
    setTimeout(() => setShowContactModal(false), 100)

  });
  const handleVideoPopup = () => {
    setShowVideoPopup(true)
  }

  const handleContactModal = () => {
    setShowContactModal(true)
    pauseVideos();
  }

  const selectDateRangeHandler = () => {
    setShowDateRangeModal(true);
    pauseVideos();
    if (showDateRangeModal) {
      document.getElementById("holidayModal")?.classList.remove("hide");
      document.getElementById("holidayModal")?.classList.add("show");
    }
    pauseVideos();
  };


  const pauseVideos = () => {
    let player = $('iframe');

    if (player) {
      player.map((index) => {
        $('iframe')[index].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        $('iframe')[index].contentWindow.postMessage('{"method":"pause","value":"' + 'pauseVideo' + '","args":""}', '*');
      })
    };
    $('.owl-item').find('video').each(function () {
      this.pause();
    });
  };

  const [state, setState] = useState({
    dates: "",
    guest: "",
    infantValidate: "",
    message: "",
  });


  const [error, setError] = useState({
    dates: false,
    guest: false,
    infantValidate: false
  })
  const id = initialPackageData && initialPackageData.id;
  // calculate days between selected dates
  const calculateDays = () => {
    const arr = [];
    if (!dataChangedBool) {
      if (
        initialPackageData &&
        initialPackageData?.schedule_type == "date_range"
      ) {
        initialPackageData &&
          initialPackageData?.schedule_data?.selectedDates?.map((date) => {
            const startDate = moment(`${date.to}`, "DD-MM-YYYY");
            const endDate = moment(`${date.from}`, "DD-MM-YYYY");
            const result = endDate.diff(startDate, "days");
            arr.push(Math.round(Math.abs(result) + 1));
          });
      }
    } else {
      if (dataChanged && dataChanged?.schedule_type == "date_range") {
        dataChanged &&
          dataChanged?.schedule_data?.selectedDates?.map((date) => {
            const startDate = moment(`${date.to}`, "DD-MM-YYYY");
            const endDate = moment(`${date.from}`, "DD-MM-YYYY");
            const result = endDate.diff(startDate, "days");
            arr.push(Math.round(Math.abs(result) + 1));
          });
      }
    }

    const min = Math.min(...arr);
    const max = Math.max(...arr);
    dateRangeMinDays = min;
    dateRangeMaxDays = max;
    if (min !== max) {
      return (
        <span>
          Min {min} {min == 1 ? "day" : "days"}, Max {max}{" "}
          {max == 1 ? "day" : "days"}
        </span>
      );
    } else {
      return (
        <span>
          {" "}
          Max {max} {min == 1 ? "day" : "days"}
        </span>
      );
    }
  };
  const packageRef = useRef()
  // const executeScrollTop = () => {

  //   packageRef?.current.scrollIntoView()
  //   dispatch(HolidaysAction.setScroll(false))
  //   window.scrollTo(0,0)

  // };
  // useEffect(() => {
  //   if (SCROLL_REF&&!loader) {
  //     executeScrollTop();
  //   }
  // }, [SCROLL_REF,loader]);
  useEffect(() => {
    packageRef?.current?.scrollIntoView()
  }, [packageRef?.current])
  const getSpecificDatesMonth = () => {
    const months = [];
    specificData?.multipleDates.map((date) => {
      months.push(moment(date).format("MMM"));
    });
    const uniqueMonths = [...new Set(months)];
    const specificDatesMonths = uniqueMonths.map((item, index) => {
      return (
        <span> {`${item}${uniqueMonths.length == index + 1 ? "" : ","} `}</span>
      );
    });
    return specificDatesMonths;
  };
  const Dates = initialPackageData?.schedule_type == "package" ? "Schedule" : "Dates"
  const handleChange = (key, value) => {
    // setState(() => ({
    //   ...state,
    //   [key]: value.target.value,
    // }));
  };

  const scrollToFormView = () => {
    var elementPosition = document.querySelector('.booking-holder').getBoundingClientRect().top;
    var add = isItinerary ? 150 : 100
    var offsetPosition = elementPosition + window.pageYOffset - add;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!state.dates || state.dates === "" || startDate === false) {
      setError({ dates: true });
      scrollToFormView();
    }
    else if (!state.guest || state.guest === "" || state.guest === `${0} adults, ${0} kids, ${0} infants`) {
      setError({ guest: true })
      scrollToFormView();
    }
    else if ((count >= 1 || childrensGuestCount >= 1) && adultGuestCount === 0) {
      setError({ infantValidate: true })
      scrollToFormView();
    }

    else {
      let data = JSON.parse(localStorage.getItem("userData"));
      let mobile = localStorage.getItem("mobile");
      let full_name = localStorage.getItem("full_name");
      const bookData = {
        pack_id: initialPackageData.id,
        adultGuestCount,
        childrensGuestCount,
        count,
        request,
        totalPrice,
        points: data.points,
        amount: totalPrice - data.points,
        name: full_name,
        email: data.user_details.email,
        contactNumber: mobile,
        startDate,
        endDate,
        resAPIStartDate,
        resAPIEndDate,
        resAPISelectedDates,
        schedule_type: dataChangedBool
          ? dataChanged?.schedule_type
          : initialPackageData?.schedule_type,
      };
      dispatch(CorporateAction.handleProceedToBook(bookData));
      dispatch(CorporateAction.changeDataforProceedToBook(dataChanged, dataChangedBool));
      dispatch(CorporateAction.handleStartAndEndDate(resAPIStartDate, resAPIEndDate, resAPISelectedDates));
      history.push("/corporate/checkout");
      window.scrollTo(0, 0);
    }
  };

  //  open guests modal
  const handleNumberOfGuests = () => {
    setShowModal(true);
    pauseVideos();
    if (showModal) {
      document.getElementById("guestModal").classList.remove("hide");
      document.getElementById("guestModal").classList.add("show");
    }
  };

  const selectDateHandler = () => {
    let packageDuration = dataChangedBool
      ? dataChanged?.schedule_data?.days?.match(/\d+/)[0]
      : initialPackageData !== undefined &&
      initialPackageData?.schedule_data?.days?.match(/\d+/)[0];
    setCalendarDuration(packageDuration);
    setShowCalenderModal(true);
    pauseVideos();
  };

  const handleDatesData = (sDate, eDate, selectedDates) => {
    setShowCalenderModal(false);
    setStartDate(sDate);
    setEndDate(eDate);
    setState(() => ({
      ...state,
      'dates': `${sDate} - ${eDate}`
    }))
    if (selectedDates && selectedDates?.length > 0) {
      setFlexiDates(selectedDates)
      setStartDate(selectedDates[0]);
      setState(() => ({
        ...state,
        'dates': selectedDates
      }))
    }
  };

  const handleResAPIStartAndEndDate = (resStartDate, resEndDate, selectedDates) => {
    setResAPIStartDate(resStartDate)
    setResAPIEndDate(resEndDate)
    setResAPISelectedDates(selectedDates)
  }

  useEffect(() => {
    if (location?.state?.id && PACKAGE_DETAILS?.corporate?.packages?.length > 0&&!SCROLL_REF) {
      PACKAGE_DETAILS?.corporate?.packages?.map((pack, idx) => {
        if (location.state.id === pack?.id && !packageChanged) {
          dispatch(CorporateAction.changePackageIndex(idx))
          setActivePackId(pack?.id)
        }
      })

    }
  }, [location?.state?.id, PACKAGE_DETAILS?.corporate?.packages])
  useEffect(()=>{
    if (location?.state?.id){
      dispatch(CorporateAction.getPackageDetails(packageID, handleLoader));
    }
  },[location?.state?.id])
  useEffect(() => {
    if (isSimilarOffer&&!packageChanged) {
      const activePkgId = localStorage.getItem("activePackageId")
      if(activePkgId){
      packageChangeHandler(activePkgId)
      }
    }
  }, [PACKAGE_DETAILS])
  useEffect(() => {
    setcategoryChanged(false)
    setCategory("Overview");
    setCategoryId("overview");
    if (isSimilarOffer || isFiltered) {
      if (isSimilarOffer) {
        setDataChangedBool(false)
        setShowDateRangeModal(false)
      }
    }
    if(packageID) {
      dispatch(CorporateAction.getPackageDetails(packageID, handleLoader));
      // setTimeout(() => {
      //   dispatch(CorporateAction.getPackageDetails(packageID, handleLoader));
      // }, 500)
    }
    // hide/show confirm button on scroll
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 950);
    });

  }, [packageID]);

  const calcTestimonialScrollHeight = () => {
    // setTestimonialSH
    if (CORPORATE_TESTIMONIALS && CORPORATE_TESTIMONIALS.length) {
      let tempTestimonialSH = {};
      CORPORATE_TESTIMONIALS?.forEach((val, index) => {
        tempTestimonialSH[`testimonial-block-${index}`] = document.getElementById(`testimonial-block-${index}`)?.scrollHeight;
      });
      setTestimonialSH(tempTestimonialSH);
    }

  };

  const handleTestimonialPopup = (item) => {
    setShowTestimonialPopup(true)
    setPopupData(item);
    pauseVideos();

  }
  useEffect(() => {
    if (initialPackageData?.id) {
      setShowDateRangeModal(false)
      dispatch(CorporateAction.ReviewPostCheck(initialPackageData?.id));
      dispatch(CorporateAction.reviewListing(initialPackageData?.id, 1));
      dispatch(CorporateAction.getTestimonials(initialPackageData?.id));
      setActivePackId(initialPackageData?.id)
    }
}, [initialPackageData?.id]);
  const handleReviewListPagination = (e, value) => {
    e.preventDefault();
    dispatch(CorporateAction.reviewListing(initialPackageData?.id, value));

  }
  useEffect(() => {
    setTimeout(() => {
      calcTestimonialScrollHeight();
    });

  }, [CORPORATE_TESTIMONIALS]);
  useEffect(() => {
    if (userInfo===null||USER_DETAILS?.user&&!isCorporate) {
      sessionStorage.setItem("corporateReadirectUrl",location?.pathname)
      history.push('/corporates',{redirectUrl:location.pathname})
      dispatch(ProfileAction.setScroll(true));
    }
  
  }, [USER_DETAILS])

  useEffect(() => {
    setotalPrice(initialPackageData?.points);
    // window.scrollTo(0,0);
  }, [initialPackageData]);

  const handleLoader = () => {
    setLoader(false);
  };
  const startLoader=()=>{
    setLoader(true)
  }
  const guestDatahandler = (adultData, childrenData, countData) => {
    setShowModal(false);
    setAdultGuestCount(adultData);
    setChildrensGuestCount(childrenData);
    setCount(countData);
    setState(() => ({
      ...state,
      'guest': `${adultData} adults, ${childrenData} kids, ${countData} infants`
    }))
  };



  const resetFormFields = () => {
    setStartDate(null);
    setEndDate(null);
    setFlexiDates([])
    setError({
      dates: false,
      guest: false,
      infantValidate: false
    });
    setState(() => ({
      ...state,
      'dates': ""
    }))
    setAdultGuestCount(0)
    setChildrensGuestCount(0)
    setCount(0)
    setRequest("")
  }
  const packageChangeHandler = (id) => {
    resetFormFields()
    PACKAGE_DETAILS?.corporate?.packages?.map((pack, idx) => {
      if (id == pack?.id) {
        dispatch(CorporateAction.getPackageDetails(packageID, handleLoader));
        setPackageChanged(true)
        dispatch(CorporateAction.changePackageIndex(idx))
        setActivePackId(id)
      }
    })

    // window.scrollTo(0, 0)
    // window.scrollTo(0, 0)
  }
  const sortedPackages = PACKAGE_DETAILS?.corporate?.packages?.map((pack, idx) => {
    return {
      id: pack?.id,
      points:pack.points
    }
  }).sort((a, b) => a.points - b.points)
  const handleShowForm = async (sDate, eDate) => {
    resetFormFields();

    if (sDate || eDate !== undefined) {
      handleResAPIStartAndEndDate(sDate, eDate, null);
      setStartDate(sDate);
      setEndDate(eDate);
      setShowPoupupDateRangeModal(false)
      setState(() => ({
        ...state,
        dates: `${sDate} - ${eDate}`,
        guest: "",
      }));
    } else {
      setState(() => ({
        ...state,
        dates: "",
        guest: "",
      }));
    }

    setShowCalenderModal(false);
    setShowForm(true);
  };
  const pointsChangeHandler = (pkgId) => {
    resetFormFields()
    dispatch(CorporateAction.getPackageDetails(packageID, handleLoader));
    let packageDuration = dataChangedBool
      ? dataChanged?.schedule_data?.days?.match(/\d+/)[0]
      : initialPackageData !== undefined &&
      initialPackageData?.schedule_data?.days?.match(/\d+/)[0];
    setCalendarDuration(packageDuration);
    setShowDateRangeModal(false);
    setDataChangedBool(true);

    PACKAGE_DETAILS?.corporate?.packages?.filter((data) => {
      if (data?.id == pkgId) {
        setDataChanged(data);
        setPackageId(data.id)
        setotalPrice(data.points);
      }
    });
    calculateDays()

  };

  //   const goBack = () => {
  //     history.goBack()
  //     localStorage.setItem('goBackToCorp', true)
  //     dispatch(HomeAction.setScroll(true));
  // }

  const getGuestCount = () => {
    // `${adultGuestCount} adult(s), ${childrensGuestCount} kid(s), ${count} infant(s)` //old code
    let tmpGuestsArray = [];
    if (adultGuestCount > 0) {
      tmpGuestsArray.push(`${adultGuestCount} adult${adultGuestCount > 1 ? 's' : ''}`);
    }
    if (childrensGuestCount > 0) {
      tmpGuestsArray.push(`${childrensGuestCount} kid${childrensGuestCount > 1 ? 's' : ''}`);
    }
    if (count > 0) {
      tmpGuestsArray.push(`${count} infant${count > 1 ? 's' : ''}`);
    }
    return tmpGuestsArray.join(', ');
  };
  const sanitisedcolumn = initialPackageData?.note
    ? "col-12 col-lg-6 "
    : "col-12 col-lg-12 ";
  const notescolumn =
    initialPackageData?.covid_safe === true
      ? "col-12 col-lg-6 "
      : "col-12 col-lg-12 ";
  const goBackFun = () => {
    let urlHistory = JSON.parse(localStorage.getItem('urlHistory'));
    if (!localStorage.getItem('prevUrl')) {
      localStorage.setItem("corporateCategory", PACKAGE_DETAILS?.corporate?.section?.id)
      history.push('/corporates');
      localStorage.setItem('goBackToCorp', true)

    } else if ((urlHistory[0].pathname === urlHistory[urlHistory.length - 1].pathname) && urlHistory.length > 2) {
      history.push('/corporates');
    } else if (localStorage.getItem('prevUrl') === '/') {
      history.push('/');
    } else {
      history.goBack();
    }
  };
  useEffect(() => {
    if (resAPIStartDate || resAPIEndDate || resAPISelectedDates?.length) {
      setError({ dates: false });
    }
  }, [resAPIEndDate, resAPIEndDate, resAPISelectedDates])
  useEffect(() => {
    if (adultGuestCount !== 0 || childrensGuestCount !== 0 || count !== 0) {
      setError({ guest: false });
    }
  }, [adultGuestCount, childrensGuestCount, count])

  useEffect(() => {
    if (showContactModal || showForm) {
      document.querySelector('html').style.overflow = "hidden"

    } else {
      document.querySelector('html').style.overflow = "scroll"
    }

  }, [showContactModal, showForm])
  const closeHandler = () => {
    resetFormFields();
    setShowForm(false);
    setShowPoupupDateRangeModal(true)
  };
  const discriptionRef = useRef();
  const stayRef = useRef();
  useEffect(() => {
    if (categoryChanged) {
      scrolltoView();
    }
  }, [categoryId, corporatesReviewListCurrentPage]);
  const scrolltoView = (id) => {
    if (isStay) {
      stayRef?.current?.scrollIntoView({
        behavior: "smooth",
      });
    } else {
      discriptionRef?.current?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  const prices = () => {

      return (
        <div className="d-flex  pricess">
          <p className="discount"><span>From</span> {!isWipro ? "Rs" : ""} {(initialPackageData.points).toLocaleString('en-IN')} {isWipro ? "pts" : ""}</p>
        </div>
      );
    
  };
  const calculateDaysProps = () => {
    if (isDateRange) {
      return calculateDays();
    } else if (isSpecific) {
      return (
        <span>
          In the month of {getSpecificDatesMonth()}{" "}
          {specificScheduleDuration(
            dataChangedBool,
            dataChanged,
            initialPackageData
          )}
        </span>
      );
    } else if (isPackage) {
      return (
        <span>
          {days && days !== "0"
            ? days && days === "1"
              ? `${days} day `
              : `${days} days `
            : ""}
          {nights && nights !== "0"
            ? nights && nights === "1"
              ? `${nights} night`
              : `${nights} nights`
            : ""}
        </span>
      );
    } else if (isRecurring) {
      return (
        <p>
          Every
          {(
            dataChangedBool
              ? dataChanged?.schedule_type == "recurring"
              : initialPackageData !== undefined &&
              initialPackageData?.schedule_type == "recurring"
          )
            ? recurringData && recurringData?.newSelectedDyas?.length > 0
              ? recurringData?.newSelectedDyas.map((index) => {
                switch (index) {
                  case 0:
                    return <span> Sun</span>;
                  case 1:
                    return <span>, Mon</span>;
                  case 2:
                    return <span>, Tue</span>;
                  case 3:
                    return <span>, Wed</span>;
                  case 4:
                    return <span>, Thu</span>;
                  case 5:
                    return <span>, Fri</span>;
                  case 6:
                    return <span>, Sat</span>;
                }
              })
              : ""
            : null}
          {scheduleDuration(dataChangedBool, dataChanged, initialPackageData)}
        </p>
      );
    } else if (isFlexible) {
      return "Flexible Days";
    }
  };
  const itineraryDescriptions = {
    overview: initialPackageData && initialPackageData?.description,
    itinerary: initialPackageData && initialPackageData?.itinerary,
    accommodation: initialPackageData && initialPackageData?.accomodations,
    essential_info: initialPackageData && initialPackageData?.essential_info,
    faqs: initialPackageData && initialPackageData.faq,
  };
  const itineraryTabData = [
    { name: "Overview", id: "overview" },
    { name: "Itinerary", id: "itinerary" },
    { name: "Accommodation", id: "accommodation" },
    { name: "Essential Info", id: "essential_info" },
    { name: "Reviews", id: "reviews" },
    { name: Dates, id: "dates" },
    { name: "FAQs", id: "faqs" },
  ];
  const stayBasedTabData = [
    { name: "Overview", id: "overview" },
    { name: "Reviews", id: "reviews" },
    { name: "Amenities", id: "amenities" },
  ];
  const itineraryFilterTabData = itineraryTabData.filter(item => {
    if (item.id === "reviews" || item.id === "dates") {

      return item

    }
    else {

      if (itineraryDescriptions[item.id] !== null) {
        if (itineraryDescriptions[item.id] !== undefined) {
          if (itineraryDescriptions[item.id] !== "") {
            if (!itineraryDescriptions[item.id]?.startsWith("<span")) {
              return item

            }
          }
        }
      }
    }
  })

  const Tabdata =
    isStay ? stayBasedTabData : itineraryFilterTabData;
  function chaneCategory(name, from) {
    if (categoryId == "dates") {
      scrolltoView()
    }
    if (from == "tab") {
      Tabdata.map((e) => {
        if (e.name == name) {
          setCategory(e.name);
          setCategoryId(e.id);
          setcategoryChanged(true);
        }
      });
    } else {
      Tabdata.map((e) => {
        if (e.id == name) {
          setCategory(e.name);
          setCategoryId(e.id);
        }
      });
    }
  }


  return (
    <div>
      <Helmet>
        <title>
          {`${dataChangedBool ?
            dataChanged !== undefined && dataChanged?.pack_title
            : initialPackageData !== undefined &&
            initialPackageData?.pack_title}`}
        </title>
        <meta
          name="description"
          content={`${dataChangedBool ? dataChanged?.brief_description :
            initialPackageData?.brief_description}`} />
      </Helmet>
      <div className="innerPage-header hide-header-mobi">
        <div className=" d-lg-none d-block">
          <Header />
        </div>
        <div className="d-none d-lg-block">
          <HolidayHeader />
        </div>
      </div>

      <div>
        {!loader ? (
          <div>
            <div ref={packageRef} className=" innerPage-container itinerary-container innerPage-container-mobi">

              <div className="package-holder">
                <div className="package-details">
                  <div className="images--holder">
                    {initialPackageData &&initialPackageData.images?.length > 0 ?
                      <PackageDetailsCarousel
                        dataChangedBool={dataChangedBool}
                        initialPackageData={initialPackageData}
                        dataChanged={dataChanged}
                      // showVideoPopup={showVideoPopup}
                      // handleVideoPopup={handleVideoPopup}
                      // popupRef={popupRef}
                      />
                      : null}
                  </div>
                  <div
                  onClick={goBackFun}
                  className="back-button-mobi back-button d-md-none"
                >
                  <img src={backIcon} alt="backIcon" />
                </div>
                  <div className={isStay ? "container-fluid row   stay-container" : "container"}>
                    <div className={isStay ? "col-lg-11 col-12 stay-header" : "row"}>


                      <div className={`itinerary-header col-12 p-0 ${!isStay && "itinerary-mob"}`}>
                        <div className={`itinerary-package-title ${packageType==null?"pb-4": !initialPackageData?.covid_safe && !initialPackageData?.note|| PACKAGE_DETAILS?.corporate?.packages
                      .length > 1 ? "pb-5" : "pb-2"}`}>
                          <div
                            onClick={goBackFun}
                            className="back-button d-none d-md-inline-flex"
                          >
                            <img src={backIcon} alt="backIcon" />
                          </div>
                          <p className={packageType === null && "d-none d-md-block"}>
                            <span>
                              {" "}
                              {initialPackageData !== undefined &&
                                initialPackageData.pack_title}
                            </span>
                          </p>
                        </div>
                        {PACKAGE_DETAILS && PACKAGE_DETAILS?.corporate?.packages
                      .length > 1 &&
                      <div className={`${isStay ? "col-lg-11" : "col-lg-12"} d-flex packages-prices p-0 ${!initialPackageData?.covid_safe && !initialPackageData?.note ? "mb-4" : ""}`}>
                      {

                        sortedPackages && sortedPackages.map((pack, idx) => (


                          <button onClick={() => packageChangeHandler(pack.id)} key={idx} className={`pkg-buttons ${pack?.id == activePackId ? "active-pkg" : "non-active-pkg"}`}><span>Rs.{(pack?.points).toLocaleString('en-IN')}</span></button>


                        ))

                      }
                    </div>
                    }
                        {packageType != null && (
                          <div
                            className={` row d-flex  ${initialPackageData?.note &&
                              !initialPackageData?.covid_safe === true
                              ? "note"
                              : `safe-note ${!initialPackageData?.note && "sanitized-row"}`
                              }  align-items-center`}
                          >
                            <div className={sanitisedcolumn}>
                              {initialPackageData &&
                                initialPackageData.covid_safe === true ? (
                                <SanitizedStayTagPopup pauseVideos={pauseVideos} />
                              ) : null}
                            </div>
                            <div className={notescolumn}>
                              {initialPackageData?.note && (
                                <PriceNote note={initialPackageData.note} />
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                   
                    {isItinerary && (
                      <ItineraryFeatures
                        data={initialPackageData}
                        calculateDays={calculateDaysProps()}
                        isInternational={isInternational}
                        chaneCategory={chaneCategory}
                        fromCorporate={true}
                        isWipro={isWipro}
                        dates={Dates}
                      />
                    )}
                    <div ref={discriptionRef}
                      id={categoryId}
                      className={
                        packageType != null
                          ? ` row ${isItinerary
                            ? "itinerary-package-Tabs-description"
                            : "packageTabs-description col-lg-11 col-12 row p-0"
                          }`
                          : "row"
                      }>
                      {isItinerary && (
                        <div className="col-12 col-lg-12">
                          <PackageTabsHolder
                            isStay={isStay}
                            isItinerary={isItinerary}
                            isStuck={isStuck}
                            setIsStuck={setIsStuck}
                            categoryChanged={categoryChanged}
                            category={category}
                            setCategory={chaneCategory}
                            Tabdata={Tabdata.map((e) => e.name)}
                          />
                        </div>
                      )}
                      <div className={
                        packageType == null || isItinerary && category === "Overview" ||
                          category === "Accommodation" ||
                          category === "Essential Info" ||
                          category === "Itinerary"
                          ? "col-12 col-lg-8 "
                          : isStay
                            ? "col-12 col-lg-9 stay-tabs-discription"
                            : "col-12 col-lg-12 "
                      }>
                        {packageType == null &&
                          <div>
                            <div className="package-title d-none d-md-block">

                              <p style={{ textAlign: "left" }}>
                                {!isInternational ? <>
                                  {initialPackageData&& initialPackageData?.location?.length > 1 ? `${(initialPackageData?.location_city || initialPackageData?.location[0]?.city)}, ${initialPackageData?.location[1]?.address}` :
                                    `${(initialPackageData?.location_city || initialPackageData?.location[0]?.city)}${(initialPackageData?.location[0]?.state)?",":""} ${(initialPackageData?.location[0]?.state)}`
                                  }
                                </> : ""
                                }
                              </p>
                              <p style={{ textAlign: "left" }}>
                                {isInternational ? <>
                                  {initialPackageData !== undefined &&
                                    initialPackageData?.location_country}
                                </> : ""
                                }
                              </p>
                              <p className="">
                                {/* <span>
                      {(packageData?.days && packageData?.days !== "0") ? (packageData?.days && packageData?.days === "1") ? `${packageData?.days} day ` : `${packageData?.days} days ` : ""} 
                      {(packageData?.nights && packageData?.nights !== "0") ? (packageData?.nights && packageData?.nights === "1") ? `${packageData?.nights} night` : `${packageData?.nights} nights` : ""}
                      </span> */}
                                {isFlexible ? <span>Flexible Days</span> : null}
                              </p>
                              {isRecurring ? (
                                <p className="">
                                  Every
                                  {(
                                    dataChangedBool
                                      ? dataChanged?.schedule_type == "recurring"
                                      : initialPackageData !== undefined &&
                                      initialPackageData.schedule_type == "recurring"
                                  )
                                    ? recurringData &&
                                      recurringData?.newSelectedDyas?.length > 0
                                      ? recurringData?.newSelectedDyas.map((index) => {
                                        switch (index) {
                                          case 0:
                                            return <span> Sun</span>;
                                          case 1:
                                            return <span>, Mon</span>;
                                          case 2:
                                            return <span>, Tue</span>;
                                          case 3:
                                            return <span>, Wed</span>;
                                          case 4:
                                            return <span>, Thu</span>;
                                          case 5:
                                            return <span>, Fri</span>;
                                          case 6:
                                            return <span>, Sat</span>;
                                        }
                                      })
                                      : ""
                                    : null}
                                  {scheduleDuration(
                                    dataChangedBool,
                                    dataChanged,
                                    initialPackageData
                                  )}
                                </p>
                              ) : (
                                ""
                              )}
                              {isSpecific || isDateRange || isPackage ? (
                                <p className="d-flex">
                                  {/* date range*/}
                                  {isDateRange ? calculateDays() : ""}

                                  {/* specific dates */}
                                  {isSpecific ? (
                                    <span>
                                      In the month of {getSpecificDatesMonth()}{" "}
                                      {specificScheduleDuration(
                                        dataChangedBool,
                                        dataChanged,
                                        initialPackageData
                                      )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  {/* package days and nights */}
                                  {isPackage ? (
                                    <span>
                                      {days && days !== "0"
                                        ? days && days === "1"
                                          ? `${days} day `
                                          : `${days} days `
                                        : ""}
                                      {nights && nights !== "0"
                                        ? nights && nights === "1"
                                          ? `${nights} night`
                                          : `${nights} nights`
                                        : ""}
                                    </span>
                                  ) : null}
                                </p>
                              ) : null}
                            </div>

                            <div
                              className="line d-none d-md-block"
                              style={{ marginTop: "-30px" }}
                            ></div>

                            {
                              // mobile view
                            }

                            <div className="package-title d-block d-md-none">
                              <h1>
                                {
                                  initialPackageData !== undefined &&
                                  initialPackageData?.pack_title}
                              </h1>
                              <p className="city-name">
                                {!isInternational ?
                                  <>{initialPackageData&& initialPackageData?.location?.length > 1 ? `${(initialPackageData?.location_city || initialPackageData?.location?.[0]?.city)}, ${initialPackageData?.location?.[1]?.address}` :
                                  `${(initialPackageData?.location_city || initialPackageData?.location[0]?.city)}${(initialPackageData?.location[0]?.state)?",":""} ${(initialPackageData?.location[0]?.state)}`
                                }
                                  </> : <span> {dataChangedBool
                                    ? dataChanged?.location_country
                                    : initialPackageData !== undefined &&
                                    initialPackageData.location_country}
                                  </span>
                                }
                              </p>

                              <p >
                                {isFlexible ? <span>Flexible Days</span> : null}
                                {isRecurring ? (
                                  <p >
                                    Every
                                    {(
                                      dataChangedBool
                                        ? dataChanged?.schedule_type == "recurring"
                                        : initialPackageData !== undefined &&
                                        initialPackageData?.schedule_type == "recurring"
                                    )
                                      ? recurringData &&
                                        recurringData?.newSelectedDyas?.length > 0
                                        ? recurringData?.newSelectedDyas.map((index) => {
                                          switch (index) {
                                            case 0:
                                              return <span> Sun</span>;
                                            case 1:
                                              return <span>, Mon</span>;
                                            case 2:
                                              return <span>, Tue</span>;
                                            case 3:
                                              return <span>, Wed</span>;
                                            case 4:
                                              return <span>, Thu</span>;
                                            case 5:
                                              return <span>, Fri</span>;
                                            case 6:
                                              return <span>, Sat</span>;
                                          }
                                        })
                                        : ""
                                      : null}
                                    {scheduleDuration(
                                      dataChangedBool,
                                      dataChanged,
                                      initialPackageData
                                    )}
                                  </p>
                                ) : (
                                  ""
                                )}
                                {isDateRange ? <p>{calculateDays()}</p> : ""}

                                {isSpecific ? (
                                  <span>
                                    In the month of {getSpecificDatesMonth()}{" "}
                                    {specificScheduleDuration(
                                      dataChangedBool,
                                      dataChanged,
                                      initialPackageData
                                    )}
                                  </span>
                                ) : (
                                  ""
                                )}

                                {isPackage ?
                                  <span>
                                    {(packageData?.days && packageData?.days !== "0") ? (packageData?.days && packageData?.days === "1") ? `${packageData?.days} day ` : `${packageData?.days} days ` : ""}
                                    {(packageData?.nights && packageData?.nights !== "0") ? (packageData?.nights && packageData?.nights === "1") ? `${packageData?.nights} night` : `${packageData?.nights} nights` : ""}
                                  </span>
                                  : ""}

                              </p>

                            </div>
                            {isWipro ? (
                              <p className="mb-price" ref={pointsEl}>
                                {(initialPackageData?.points).toLocaleString('en-IN')} pts{" "}
                              </p>
                            ) : (
                              <p className="mb-price" ref={pointsEl}>
                                Rs {(initialPackageData?.points).toLocaleString('en-IN')}{" "}
                              </p>
                            )}

                            {/* <div className="select-points">
                      <form>
                        <div className="d-flex flex-wrap">
                          {PACKAGE_DETAILS &&
                            PACKAGE_DETAILS.corporate?.packages.length > 0 &&
                            PACKAGE_DETAILS.corporate?.packages.map((pkg, index) => (
                              <div>
                                <input
                                  type="radio"
                                  id={"points"[index]}
                                  name="points"
                                  value={pkg.id}
                                  onClick={() => pointsChangeHandler(pkg.id)}
                                  defaultChecked={
                                    PACKAGE_DETAILS.corporate?.packages[0].id === pkg.id
                                  }
                                />
                                {
                                  isWipro ?  <label for={"points"[index]} ref={pointsEl}>
                                  {pkg.points} pts{" "}
                                </label> :  <label for={"points"[index]} ref={pointsEl}>
                                Rs {pkg.points}
                              </label>
                                }
                               
                              </div>
                            ))}
                        </div>
                      </form>
                    </div> */}
                            {dataChangedBool
                              ? (dataChanged?.note ? (
                                <PriceNote
                                  note={dataChangedBool
                                    ? dataChanged?.note
                                    : initialPackageData?.note}
                                />) : null) : initialPackageData?.note ? (<PriceNote
                                  note={dataChangedBool
                                    ? dataChanged?.note
                                    : initialPackageData?.note}
                                />) : null}
                            {
                              dataChangedBool ? (dataChanged.covid_safe === true ? <SanitizedStayTagPopup pauseVideos={pauseVideos} /> : null) : (initialPackageData.covid_safe === true ? <SanitizedStayTagPopup pauseVideos={pauseVideos} /> : null)
                            }
                          </div>
                        }
                        {isStay && (
                          <StayFeaturesCard
                            initialPackageData={
                              initialPackageData && initialPackageData
                            }
                            fromCorporate={true}
                            isWipro={isWipro}
                            isInternational={isInternational}
                            calculateDays={calculateDaysProps()}
                          />
                        )}
                        <div
                          className={
                            isStay
                              ? "stay-package-tabs-description"
                              : ""
                          }
                        >
                          {isStay && (
                            <PackageTabsHolder
                              category={category}
                              setCategory={chaneCategory}
                              Tabdata={Tabdata.map((e) => e.name)}
                              isStay={isStay}
                              isItinerary={isItinerary}
                              isStuck={isStuck}
                              setIsStuck={setIsStuck}
                            />
                          )}
                          <div ref={stayRef}
                            className={
                              isItinerary
                                ? "itinerary-package-description stay-desc" : isStay && isStuck ? "stay-sticky-description stay-desc"
                                  : isStay
                                    ? "stay-package-description stay stay-desc"
                                    : "package-description"
                            }>
                            {/* <p className="mb-1">
                        Duration :{" "}
                        {dataChangedBool
                          ? dataChanged?.schedule_data?.days
                          : initialPackageData !== undefined &&
                          initialPackageData?.schedule_data?.days} {(dataChanged?.schedule_data?.days == 1 || initialPackageData?.schedule_data?.days == 1 ) ? 'Day' : 'Days' }  and {dataChangedBool
                            ? dataChanged?.schedule_data?.nights
                            : initialPackageData !== undefined &&
                            initialPackageData?.schedule_data?.nights} {(dataChanged?.schedule_data?.nights == 1 || initialPackageData?.schedule_data?.nights == 1) ? 'Night' : 'Nights'
                            } </p> */}
                            {packageType === null && (
                              <p className="mb-3">
                                Validity till :{" "}
                                {dataChangedBool
                                  ? moment(dataChanged.valid_till).format('Do MMMM, YYYY')
                                  : initialPackageData !== undefined &&
                                  moment(initialPackageData.valid_till).format('Do MMMM, YYYY')}
                              </p>
                            )}
                            {category !== "Amenities" && category !== "Reviews" && categoryId !== "dates" &&
                              <p dangerouslySetInnerHTML={{
                                __html: itineraryDescriptions[categoryId]
                              }}>
                              </p>
                            }
                            {categoryId === "dates" && (
                              <ItineraryPackageDates
                                packageData={
                                  initialPackageData &&
                                  initialPackageData?.schedule_data?.selectedDates
                                }
                                handleShowForm={handleShowForm}
                                setShowForm={setShowForm}
                                calculateDaysProps={calculateDaysProps}
                              />
                            )}
                            {category === "Amenities" && (
                              <Amenities
                                initialPackageData={
                                  initialPackageData && initialPackageData
                                }
                              />
                            )}
                            {category === "Reviews" && (
                              <CustomerReviews
                                packageTitle={
                                  initialPackageData &&
                                  initialPackageData.pack_title
                                }
                                Id={id}
                                reviewList={reviewList}
                                reviewStatus={reviewStatus}
                                isFromCorporate={true}
                                chaneCategory={chaneCategory}
                                referenceId={referenceId}
                                totalPage={corporatesReviewListTotalPage}
                                handlePagination={handleReviewListPagination}
                                currentPage={corporatesReviewListCurrentPage}
                              />
                            )}

                          </div>
                        </div>
                      </div>
                      <div className={
                        packageType == null ||
                          isItinerary && category === "Overview" ||
                          category === "Accommodation" ||
                          category === "Essential Info" ||
                          category === "Itinerary" ||
                          showForm
                          ? "col-12 col-lg-4"
                          : isStay
                            ? "col-12 col-lg-3 stay-forms"
                            : "d-none"
                      }>
                        {packageType == null && (
                          <div>
                            {isWipro ? (
                              <p className="price" ref={pointsEl}>
                                {(initialPackageData?.points).toLocaleString('en-IN')} pts{" "}
                              </p>
                            ) : (
                              <p className="price" ref={pointsEl}>
                                Rs {(initialPackageData?.points).toLocaleString('en-IN')}{" "}
                              </p>
                            )}
                          </div>)
                        }
                        <div className={showForm ? "tour-planner-model" : ""}>
                          <div
                            ref={myRef}
                            className={
                              showForm
                                ? "login-holder booking-holder contact-tour-planner"
                                : "login-holder booking-holder "
                            }
                          >
                            <span className="d-flex" onClick={closeHandler}>
                              <img
                                src={closeIcon}
                                alt='closeIcon'
                                className={
                                  showForm ? "d-block close-icon" : "d-none"
                                }
                              />
                            </span>
                            {/* <h5>Fill the below details</h5> */}

                            {/* <p className="fill-details">
                        Fill details below to proceed
                    </p> */}
                            {isStay && (
                              <div className="stay-price  d-flex flex-column  align-items-center">
                                {prices()}
                                <p>{calculateDaysProps()}</p>
                              </div>
                            )}
                            <form onSubmit={submitHandler}>
                              {(
                                dataChangedBool
                                  ? dataChanged?.schedule_type == "date_range"
                                  : initialPackageData !== undefined &&
                                  initialPackageData?.schedule_type ==
                                  "date_range"
                              ) ? (
                                <div className="form-group position-relative">
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="From - To"
                                    readOnly
                                    onClick={selectDateRangeHandler}
                                    value={
                                      startDate && endDate !== null
                                        ? `${moment(
                                          startDate,
                                          "DD-MM-YYYY"
                                        ).format("ddd-DD MMM ")} to ${moment(
                                          endDate,
                                          "DD-MM-YYYY"
                                        ).format("ddd-DD MMM")}`
                                        : ""
                                    }
                                    onChange={(value) =>
                                      handleChange("dates", value)
                                    }
                                  />
                                  <label for="">Preferred dates</label>
                                  {error.dates === true ? (
                                    <div className="errorMsg text-center">
                                      Please select dates
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {showDateRangeModal && showPoupupDateRangeModal && (
                                    <HolidayRangePicker
                                      showMyModal={showDateRangeModal}
                                      handleDatesData={handleDatesData}
                                      handleResAPIStartAndEndDate={
                                        handleResAPIStartAndEndDate
                                      }
                                      dateRangeMinDays={dateRangeMinDays}
                                      dateRangeMaxDays={dateRangeMaxDays}
                                      dateList={
                                        dataChangedBool
                                          ? dataChanged?.schedule_data
                                            .selectedDates
                                          : initialPackageData !== undefined &&
                                          initialPackageData?.schedule_data
                                            .selectedDates
                                      }
                                    />
                                  )}
                                </div>
                              ) : (
                                <div className="form-group position-relative">
                                  {isDateRange || isPackage ? (
                                    <input
                                      className="form-control"
                                      type="text"
                                      readOnly
                                      placeholder={
                                        isPackage
                                          ? "Check in - Check out"
                                          : "Select dates"
                                      }
                                      onClick={selectDateHandler}
                                      value={
                                        startDate && endDate !== null
                                          ? `${moment(startDate).format(
                                            "ddd-DD MMM"
                                          )} to ${moment(endDate).format(
                                            "ddd-DD MMM"
                                          )}`
                                          : ""
                                      }
                                      onChange={(value) =>
                                        handleChange("dates", value)
                                      }
                                    />
                                  ) : !isFlexible ? (
                                    <input
                                      className="form-control"
                                      type="text"
                                      readOnly
                                      placeholder={
                                        isPackage
                                          ? "Check in - Check out"
                                          : "Select a date"
                                      }
                                      onClick={selectDateHandler}
                                      value={
                                        startDate && endDate !== null
                                          ? `${moment(startDate).format(
                                            "ddd-DD MMM"
                                          )}`
                                          : ""
                                      }
                                      onChange={(value) =>
                                        handleChange("dates", value)
                                      }
                                    />
                                  ) : (
                                    <div className="flexiDates">
                                      <input
                                        className={
                                          flexiDatesLength > 2
                                            ? "form-control text-left pl-0"
                                            : "form-control"
                                        }
                                        type="text"
                                        readOnly
                                        placeholder={
                                          isFlexible ? "Select dates" : ""
                                        }
                                        onClick={selectDateHandler}
                                        value={
                                          flexiDates && flexiDates.length > 0
                                            ? flexiDates && flexiDates.length == 1
                                              ? `${moment(
                                                flexiDates[0],
                                                "DD-MM-YYYY"
                                              ).format("ddd-DD MMM")} `
                                              : `${moment(
                                                flexiDates[0],
                                                "DD-MM-YYYY"
                                              ).format("ddd-DD MMM")}, ${moment(
                                                flexiDates[1],
                                                "DD-MM-YYYY"
                                              ).format("ddd-DD MMM")} `
                                            : ""
                                        }
                                        onChange={(value) =>
                                          handleChange("dates", value)
                                        }
                                      />
                                      {flexiDatesLength > 2 ? (
                                        <span onClick={selectDateHandler}>
                                          +{flexiDatesLength - 2} more
                                        </span>
                                      ) : null}
                                    </div>
                                  )}

                                  <label for="">
                                    {isPackage
                                      ? "Preferred dates"
                                      : "Preferred dates"}
                                  </label>
                                  {error.dates === true ? (
                                    <div className="errorMsg text-center">
                                      Please pick a date
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {showCalenderModal ? (
                                    <CalenderModal
                                      duration={calendarDuration}
                                      showMyModal={showCalenderModal}
                                      handleDatesData={handleDatesData}
                                      handleResAPIStartAndEndDate={
                                        handleResAPIStartAndEndDate
                                      }
                                      isRecurring={isRecurring}
                                      recurringData={
                                        isRecurring ? recurringData : ""
                                      }
                                      packageDays={days}
                                      packageNights={nights}
                                      isExperience={true}
                                      isPackage={isPackage}
                                      isSpecific={isSpecific}
                                      isFlexible={isFlexible}
                                      // maxDate={maxDate}
                                      value={flexiDates}
                                      prevStartDate={startDate}
                                      prevEndDate={endDate}
                                      getSpecificDatesMonth={
                                        getSpecificDatesMonth
                                      }
                                      recurringDaysList={
                                        dataChangedBool
                                          ? dataChanged?.schedule_data
                                            ?.newSelectedDyas
                                          : initialPackageData !== undefined &&
                                          initialPackageData?.schedule_data
                                            ?.newSelectedDyas
                                      }
                                      specificDaysList={
                                        dataChangedBool
                                          ? dataChanged?.schedule_data
                                            ?.multipleDates
                                          : initialPackageData !== undefined &&
                                          initialPackageData?.schedule_data
                                            ?.multipleDates
                                      }
                                    />
                                  ) : null}
                                </div>
                              )}
                              {/* <div className="form-group position-relative">
                          {!isFlexible ? 
                            <input
                              className="form-control"
                              type="text"
                              readOnly
                              placeholder="Check in - Check out"
                              onClick={selectDateHandler}
                              value={
                                startDate &&
                                  endDate !== null ?
                                  `${moment(startDate).format('ddd-DD MMM')} to ${moment(endDate).format('ddd-DD MMM')}` : ""
                              }
                              onChange={(value) => handleChange("dates", value)}
                            /> : 
                            <div className="flexiDates">
                                <input

                                    className={ flexiDatesLength > 2 ? "form-control text-left pl-0" : "form-control"}
                                    type="text"
                                    placeholder={isFlexible ? 'Select dates' : ""}
                                    onClick={selectDateHandler}
                                    readOnly
                                    value={ flexiDates && flexiDates.length > 0 ?
                                        flexiDates && flexiDates.length == 1 ? 
                                        `${moment(flexiDates[0], 'DD-MM-YYYY').format('ddd-DD MMM')} `:  `${moment(flexiDates[0], 'DD-MM-YYYY').format('ddd-DD MMM')}, ${moment(flexiDates[1], 'DD-MM-YYYY').format('ddd-DD MMM')} ` : ""
                                    }
                                    onChange={(value) => handleChange("dates", value)}
                                />
                                {flexiDatesLength > 2 ?
                                <span  onClick={selectDateHandler}>
                                    +{flexiDatesLength - 2} more
                                    </span> : 
                                null }
                            </div>
                          }   
                          <label for="">Preferred dates</label>
                          {error.dates === true ? <div className="errorMsg text-center">Please select dates</div> : ""}
                          {showCalenderModal ? (
                            <CalenderModal
                              duration={calendarDuration}
                              showMyModal={showCalenderModal}
                              handleDatesData={handleDatesData}
                              handleResAPIStartAndEndDate={handleResAPIStartAndEndDate}
                              packageDays={days}
                              packageNights={nights}
                              isPackage={isPackage}
                              isFlexible={isFlexible}
                              value={flexiDates}
                              prevStartDate={startDate}
                              prevEndDate={endDate}
                            />
                          ) : null}
                        </div> */}
                              <div className="form-group position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  readOnly
                                  placeholder="Number of guests"
                                  onChange={(value) => handleChange("guest", value)}
                                  onClick={handleNumberOfGuests}
                                  value={
                                    adultGuestCount !== 0 ||
                                      childrensGuestCount !== 0 ||
                                      count !== 0
                                      ? getGuestCount()
                                      : ""
                                  }
                                />
                                <label for="">Guests</label>
                                {error.guest === true ? <div className="errorMsg text-center">Please enter number of guests</div> : null}
                                {error.infantValidate === true ? <div className="errorMsg text-center">For Infants/children at least 1 adult is required
                                </div> : null}
                                {
                                  showModal && <GuestsModal
                                    showMyModal={showModal}
                                    guestDatahandler={guestDatahandler}
                                    adultCount={adultGuestCount}
                                    childrensCount={childrensGuestCount}
                                    infantCount={count}
                                  />
                                }
                              </div>
                              {/* <div className="form-group specific-request">
                          <label for="">Any specific request</label>
                          <div className="custom-request">
                            <input type="text"
                              name=""
                              id=""
                              placeholder="Enter here"
                              value={request}
                              onChange={(e) => setRequest(e.target.value)}
                            />
                            <div class="form-line"></div>
                            <div className="example">
                              <p>Example:</p>
                              <p>I am out of points, Can I extend my stay by paying</p>
                            </div>
                          </div>
                        </div> */}
                              <div className="line-custom"></div>
                              {isEnablePayment && <div className="total-amount">
                                {
                                  isWipro ? <p></p> : <p></p>
                                }

                              </div>}
                              <div>
                                <button
                                  type="submit"
                                  className="btn proceed-to-book w-100" >
                                  {isEnablePayment ? `Proceed to book` : `Enquire now`}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                        <ItineraryEnquiryForm
                          showForm={showForm}
                          packageType={packageType}
                          isInternational={isInternational}
                        />

                        <div className={`d-none ${packageType == null ? "d-md-block" : ""
                          }  sticky-contact`}>
                          <ContactDetailsCard isEnablePayment={isEnablePayment} isInternational={isInternational} />
                        </div>

                      </div>
                      {
                        showContactModal ? <div className="contact-modal">
                          <ContactDetailsCard openModal={setShowContactModal} contactModalRef={contactModalRef} isInternational={isInternational} />
                        </div> : null
                      }
                    </div>
                    {CORPORATE_TESTIMONIALS && CORPORATE_TESTIMONIALS?.length > 0 ?
                      <div className={isStay ? "col-lg-11 col-12" : ""}>
                        <Testimonials testimonialsData={CORPORATE_TESTIMONIALS} testimonialSH={testimonialSH} handleTestimonialPopup={handleTestimonialPopup} />
                      </div> : null}

                  </div>
                </div>

              </div>

              {/* {
                  PACKAGE_DETAILS && packageIdGet ? (
                    <SimilarOffers
                      similarPackages={
                        dataChangedBool ? dataChanged?.id : initialPackageData?.id
                      }
                      similarPackageEmptyData={similarPackageEmptyData}
                    />
                  ) : null
                } */}
              {
                <NearByExperiences
                  similarExperiences={dataChangedBool ? dataChanged?.id : initialPackageData?.id}
                  startLoader={startLoader}
                  resetFormFields={resetFormFields}
                  
                  setPackageChanged={setPackageChanged}
                />
              }
              {<ViewMorePackages similarExperiences={dataChangedBool ? dataChanged?.id : initialPackageData?.id}
                secName={PACKAGE_DETAILS?.corporate?.section?.name}
                startLoader={startLoader}
                resetFormFields={resetFormFields}
                
                setPackageChanged={setPackageChanged}
              />}




            </div>
            {
              showTestimonialPopup ?
                <TestimonialPopup openModal={setShowTestimonialPopup} item={popupData} /> : null
            }

            <div className={scroll ? "d-none" : "d-block"}>
              <div className="mobile-buttons">
                <div className="stcky-leftButton">
                  <div className="white-button" onClick={handleContactModal}>
                    <a >Contact</a>
                  </div>
                </div>
                <div className="stcky-rightButton">
                  <div className="custom-button" onClick={executeScroll}>
                    <a>   {isItinerary ? Dates : isEnablePayment
                      ? `Book this`
                      : `Enquire Now`}    </a>
                  </div>
                </div>
              </div>
            </div>


            <Footer />
          </div>
        ) : <Loader />} </div>
      <ScrollToTop />
    </div>
  );
};

export default withRouter(PackageDetails);